import React from 'react';

const Linkedin = React.memo(({ color, ...props }) => <svg width="44" height="44" viewBox="0 0 44 44" {...props}>
    <circle cx="22" cy="22" r="22" style={{ fill: color }} />
    <path d="M33,32H28.14V25c0-1.84-.76-3.1-2.43-3.1a2.45,2.45,0,0,0-2.32,1.67,3.1,3.1,0,0,0-.1,1.11V32H18.47s.06-12.45,0-13.59h4.82v2.13c.29-.93,1.82-2.26,4.28-2.26,3,0,5.44,2,5.44,6.16V32h0ZM13.59,16.71h0A2.37,2.37,0,0,1,11,14.58v-.22a2.62,2.62,0,1,1,2.87,2.34h-.28Zm-2,1.7h4.29V32H11.55V18.41Z" style={{ fill: '#fff' }} />
</svg>);

export default Linkedin;

Linkedin.defaultProps = {
    width: '34px',
    height: '34px',
    color: '#007fbe',
};